<template>
    <div>
        <preloader :display="loading" />
        <div class="card-container dflex">
            <div v-if="shouldShowCreditCard">
                <h4>{{ $l10n.__('Votre carte de paiement') }}</h4>
                <div v-if="cardValidationInProgress">
                    <credit-card-template
                        :validationInProgress="cardValidationInProgress"
                        :validationMessage="$t.__('common.labels.card_being_validated')"
                        :placeholder="$t.__('common.labels.no_card_saved')"
                    />
                </div>
                <div v-else>
                    <credit-card-template :creditcard="customerCreditCard" />
                </div>
            </div>
            <div>
                <h4 class="mb-5">{{ $l10n.__('Ajouter une carte de paiement') }}</h4>
                <p v-if="shouldShowCreditCard">
                    {{ $l10n.__('Ou définir une nouvelle carte de paiement') }}
                </p>
                <div style="height: 50px">
                    <el-form
                        ref="stripeForm"
                        labelPosition="top"
                        :inline="false"
                        :inlineMessage="true"
                        :model="stripeForm"
                    >
                        <el-form-item :label="$t.__('common.labels.credit_card')" prop="creditcard">
                            <div id="creditcard">
                                <!-- A Stripe Element will be inserted here. -->
                            </div>
                        </el-form-item>
                    </el-form>
                </div>

                <span v-if="errors.get('card-number')" class="red error"
                    >{{ errors.get('card-number') }}<br
                /></span>
                <span v-if="errors.get('card-expiry')" class="red error"
                    >{{ errors.get('card-expiry') }}<br
                /></span>
                <span v-if="errors.get('card-cvc')" class="red error"
                    >{{ errors.get('card-cvc') }}<br
                /></span>
            </div>
        </div>
    </div>
</template>

<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';
import FormMixins from '../../../mixins/FormMixins';
import SAMMixins from '../../../mixins/subscription/SAMMixins';
import CreditCardTemplate from '../billingsettings/CreditCardTemplate.vue';
import WidgetMixins from '../../../mixins/sellsyaccountmanager/widgetMixins';
import Env from 'Services/Env';

export default {
    components: {
        Preloader,
        CreditCardTemplate,
    },
    mixins: [FormMixins, SAMMixins, WidgetMixins],
    props: {
        corporation: {
            type: String | Number,
            required: false,
        },
    },
    data() {
        return {
            stripeForm: {},
            loadedInMixin: true,
            loading: false,
            cardValidationInProgress: false,
            publishableKey: Env.get('stripe').publishableKey,
        };
    },
    computed: {
        shouldShowCreditCard() {
            return (
                this.userIsLogged && !!this.customerCreditCard && !this.customerCreditCard.isExpired
            );
        },
    },
    created() {
        if (!this.userIsLogged) {
            return;
        }
        this.loading = true;
        this.getActiveCreditCard(this.corporation)
            .then((creditCard) => {
                if (creditCard.isExpired) {
                    Push.warning(this.$l10n.__('La carte a expiré'));
                }
                return creditCard;
            })
            .then((creditCard) => {
                !creditCard.error && !creditCard.isExpired
                    ? this.setCustomerCreditCard(creditCard)
                    : null;
            })
            .finally(() => (this.loading = false));
    },
    methods: {
        refreshCreditcard() {
            this.loading = true;
            return this.getActiveCreditCard(this.corporation)
                .then((card) => {
                    this.stripeElement.clear();
                    if (card.error) {
                        this.setCustomerCreditCard(false);
                        this.cardValidationInProgress = true;
                    } else {
                        this.setCustomerCreditCard(card);
                    }
                })
                .finally(() => (this.loading = false));
        },
    },
};
</script>

<style scoped lang="scss">
.card-container {
    justify-content: space-between;

    & > div {
        flex-grow: 1;
    }
}
</style>
